module.exports = __webpack_public_path__ + "static/img/moreindustry3.6c80df11.png";